const textColors = {
	primaryText: '#181818', // Easy Black
	coinbaseTableHeaderText: 'rgba(17, 51, 83, 0.6)',
};

export default textColors;
